module.exports = __webpack_public_path__ + "static/media/svg-3.d43598ef.svg";